import { PropsWithChildren, memo } from 'react';

import styled, { StyledProp, css } from '@/styled';

export const CONTAINER_MAX_WIDTH = 1440;
export const DESKTOP_MARGIN = 15.5; // 62px
export const TABLET_MARGIN = 8; // 32px
export const MOBILE_MARGIN = 4; // 16px

type WrapperSize = 'medium' | 'large';

interface WrapperProps extends StyledProp, PropsWithChildren {
  size?: WrapperSize;
}

/**
 * Use only to limit content size
 * @example Pages, Sections, etc...
 */
const Wrapper = ({ className, children }: WrapperProps) => {
  return <div className={className}>{children}</div>;
};

export default memo(styled(Wrapper, { label: 'wrapper' })`
  ${({ theme, size = 'large' }) => {
    const sizeMap = {
      medium: 840,
      large: 1440
    };

    return css`
      max-width: 100%;
      margin: 24px auto;
      width: ${sizeMap[size]}px;
      padding: ${theme.space.spacing(0, DESKTOP_MARGIN)};

      ${theme.breakpoints.down('md')} {
        padding: ${theme.space.spacing(0, TABLET_MARGIN)};
      }

      ${theme.breakpoints.down('sm')} {
        padding: ${theme.space.spacing(0, MOBILE_MARGIN)};
      }
    `;
  }}
`);
